import React from 'react';
import { ThumbUpSharp as SuccessIcon } from '@material-ui/icons';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { Dialog, useMediaQuery, Grid, Typography, DialogContent, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: 200,
        borderRadius: '50%',
        padding: theme.spacing(1),
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        color: theme.palette.grey[500],
        background: theme.palette.grey[200],
    },
    btn: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
}));


export default function SuccessReverifyModal(props) {
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { open, onClose, message } = props;

    function handleClose() {
        onClose();
    }

    if (!open) {
        return null;
    }

    return (
        <React.Fragment>
            <Dialog
                disableEscapeKeyDown={false}
                disableBackdropClick={false}
                fullScreen={fullScreen}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="sm"
                keepMounted
                open={open}
            >
                <DialogContent>
                    <Grid container justify="center" alignItems="center">
                        <Grid item container>
                            <Grid item container justify="center">
                                <SuccessIcon className={classes.icon}/>
                            </Grid>

                            <Grid item container justify="center">
                                <Grid item>
                                    <Typography variant="h6">
                                        SUCCESS!
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid item container justify="center">
                                <Grid item>
                                    <Typography variant="body1" color="textSecondary">
                                        {message}
                                    </Typography>
                                </Grid>
                            </Grid>
                            
                            <Grid item container justify="center">
                                <Button variant="outlined" onClick={handleClose} className={classes.btn}>
                                    OK
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
